import {GraphObject, SvgRendererOptions} from 'gojs';

export const APPLICATION_SVG_RENDERER_OPTIONS: SvgRendererOptions = {
    scale: 1,
    background: 'white',
    elementFinished: elementFinishedCallback
};

function elementFinishedCallback(graphObject: GraphObject, svgElement: SVGElement) {
    if (graphObject.name === 'RICH') {
        // Replace rich text nodes with their HTML representation so that text can be copied from the SVG
        const node = graphObject.findBindingPanel().data;
        // tslint:disable-next-line:max-line-length
        svgElement.outerHTML = `<foreignObject width="${node.width}" height="${node.height}"><body xmlns="http://www.w3.org/1999/xhtml">${node.html}</body></foreignObject>`;
    }
}
